module.exports = __webpack_public_path__ + "static/img/logo01.ad9c636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo01.png
// module id = 116
// module chunks = 55